import React, { useContext } from 'react';
import VisitsReport from './visitsReport';
import VisitDetails from './visitDetails';
import StepsContext from '../../../contexts/stepsContext';

const componentsSteps = [<VisitsReport />, <VisitDetails />];
const FormsRegister = () => {
  const steps = useContext(StepsContext);
  const { step } = steps;

  return <React.Fragment>{componentsSteps[step.page]}</React.Fragment>;
};

export default FormsRegister;
